var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PinOptions"},_vm._l((_vm.pins),function(pin,id){return _c('OptionPin',{key:id,attrs:{"id":id,"pin":pin}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }